module.exports = {
  title: 'Particles Button with Reanimated and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2025-04-08',
  slug: 'particles-button',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
